<template>
  <div class="container-fluid crm-page-wrapper error-404">
    <center>
      <v-img contain width="400" height="100%" :src="items[0].url"></v-img>
    </center>
    <!-- <h1>404 not found</h1>
    <p>ไม่พบ URL ของหน้าเว็บไซต์นี้</p> -->
  </div>
</template>
<script>

export default {
  data () {
    return {
      items: [
        {
          url: require('@/assets/ErrorAndRenovation/Group656.png')
        }
      ]
    }
  }
}
</script>
<style>
.error-404 {
    text-align: center;
    align-items: center;
    background-color: white;
    justify-content: center;
    padding-top: 5%;
    padding-bottom: 10%;
}
</style>
